import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { studentFeedbackGridDataService } from 'common/services/data-services/student-feedback/student-feedback-data-service';
import { studentFeedbackGridMetaModel } from 'common/models/page-models/student-feedback/student-feedback-grid-meta-model';
import { studentFeedbackListingModel } from 'common/models/page-models/student-feedback/student-feedback-grid-model';
import { studentFeedbackModel } from 'common/models/page-models/student-feedback/student-feedback-model';
 
@Injectable({
    providedIn: 'root'
})
export class studentFeedbackGridWidgetService extends GridWidgetService<studentFeedbackModel, studentFeedbackListingModel> {
    constructor(protected override ds: studentFeedbackGridDataService, protected systemService: SystemService) {
        super(ds);

    }
 
    getMetaModel(): MetaModel {
        const meta = new studentFeedbackGridMetaModel().getMetaModel();
        return meta;
    }
}